import { AppUserMergeState, AppUserMergeTypes } from './types';

export const INITIAL_STATE: AppUserMergeState = {
  appUserMergeList: [],
  cardIndex: 1,
  totalCount: 0,
  error: false,
  loading: false,
};

function createReducer(initialState = INITIAL_STATE, handlers: any) {
  return function reducer(state = initialState, action: any) {
    // eslint-disable-next-line
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

// App User Merge - List
const listAppUserMergeRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  appUserMergeList: INITIAL_STATE.appUserMergeList,
});

const listAppUserMergeSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  appUserMergeList: action.payload.appUserMergeList,
  totalCount: action.payload.totalCount,
});

const listAppUserMergeFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  appUserMergeList: INITIAL_STATE.appUserMergeList,
});

// App User Merge - Update
const updateAppUserMergeRequest = (state: any, action: any) => ({
  ...state,
  loading: Boolean(action.payload.name),
  error: false,
});

const updateAppUserMergeSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const updateAppUserMergeFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Current Card
const currentCardUpdated = (state: any, action: any) => ({
  ...state,
  cardIndex: action.payload.cardIndex,
});

const reducer = createReducer(INITIAL_STATE, {
  [AppUserMergeTypes.LIST_APP_USER_MERGE_REQUEST]: listAppUserMergeRequest,
  [AppUserMergeTypes.LIST_APP_USER_MERGE_SUCCESS]: listAppUserMergeSuccess,
  [AppUserMergeTypes.LIST_APP_USER_MERGE_FAILURE]: listAppUserMergeFailure,

  [AppUserMergeTypes.UPDATE_APP_USER_MERGE_REQUEST]: updateAppUserMergeRequest,
  [AppUserMergeTypes.UPDATE_APP_USER_MERGE_SUCCESS]: updateAppUserMergeSuccess,
  [AppUserMergeTypes.UPDATE_APP_USER_MERGE_FAILURE]: updateAppUserMergeFailure,

  [AppUserMergeTypes.APP_USER_MERGE_CURRENT_CARD]: currentCardUpdated,
});

export default reducer;
